module.exports = __webpack_public_path__ + "static/media/naverLogo.2181efd8.svg";